import { type Readable, derived } from 'svelte/store';
import { user, config } from '$lib/stores';

export const DEFAULT_LOCALE = 'en-GB';

export const MARKET_TO_LOCALE: Record<string, string> = {
	DE: 'de-DE',
	FR: 'fr-FR',
	ES: 'es-ES',
	IT: 'it-IT',
	UK: 'en-GB',
	NL: 'nl-NL',
	SE: 'sv-SE',
};

export function localeFromMarket(market: string | undefined | null): string {
	if (!market) {
		return DEFAULT_LOCALE;
	}
	return MARKET_TO_LOCALE[market] ?? DEFAULT_LOCALE;
}

const marketLocale: Readable<string> = derived(
	[user, config],
	([$user, $config]) => localeFromMarket($user?.market ?? $config?.market)
);

export default marketLocale;
